import React from 'react';
import {
    BooleanField,
    Button,
    DateField,
    EditButton,
    FunctionField,
    Link,
    ReferenceField,
    ReferenceManyField,
    RichTextField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField,
} from 'react-admin';
import ExternalUrlField from '../inputs/ExternalUrlField';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import { Tree, NodeView, NodeActions } from 'ra-tree-ui-materialui';

const PostsActions = props => (
    <NodeActions {...props}>
        <EditButton />
        <AddNewPostButton />
    </NodeActions>
);

const AddNewPostButton = ({ record }) => (
    <Button
        component={Link}
        label="Add a Reply"
        to={`/posts/create?parent=${record.id}&thread=${record.thread}&user=/users/${window.localStorage.getItem('ltk-comments-admin-id')}`}
        title="Add a Reply"
    >
        <ChatBubbleIcon />
    </Button>
);

const PostTitle = ({ record }) => {
    return <span>Thread { record ? `"${record.thread.title}" - Post ${record.id}` : '' }</span>
};

const RepliesTree = (props)=>(
        <Tree {...props}>
            <NodeView actions={<PostsActions />}>
                <ReferenceField label="User" source="user" reference="users">
                    <TextField source="username" />
                </ReferenceField>
                <RichTextField source="message" />
                <DateField disabled label="Created" source="created_at" showTime />
            </NodeView>
        </Tree>
);
RepliesTree.defaultProps = {
    data: {},
    ids: [],
};

export const PostShow = (props) => (
    <Show title={<PostTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="Post">
                <FunctionField label="ID" render={record => `${record.id.replace(/\/posts\//, '')}`} />
                <ReferenceField label="Thread" source="thread" reference="threads">
                    <TextField source="title" />
                </ReferenceField>
                <ReferenceField label="Link to Thread" reference="threads" source="thread" linkType={false}>
                    <ExternalUrlField source="link" />
                </ReferenceField>
                <TextField label="Parent" source="parent" />
                <ReferenceField label="User" source="user" reference="users">
                    <TextField source="username" />
                </ReferenceField>
                <BooleanField label="Is Approved?" source="approved" />
                <BooleanField label="Needs Review?" source="needs_review" />
                <BooleanField label="Is Spam?" source="spam" />
                <BooleanField label="Has Profanity?" source="profanity" />
                <BooleanField label="Has Links?" source="links" />
                <DateField disabled label="Updated" source="updated_at" showTime />
                <DateField disabled label="Created" source="created_at" showTime />
            </Tab>
            <Tab label="Message" path="message">
                <RichTextField label="Message" source="message" />
            </Tab>
            <Tab label="Posts" path="replies">
                <ReferenceManyField
                    sort={{ field: 'createdAt', order: 'DESC' }}
                    label="Replies"
                    reference="posts"
                    target="parent"
                    perPage={10000}
                >
                    <RepliesTree/>
                </ReferenceManyField>
                <AddNewPostButton />
            </Tab>
        </TabbedShowLayout>
    </Show>
);
